/**
 * Ruta de los assets de la página de Odontología.
 * Sigue la convención del proyecto (ver Testimonials.tsx).
 */
export const dentalAsset = (file: string) => `${import.meta.env.BASE_URL}${file}`;
